import { RouteObject, Navigate } from "react-router-dom";
import LandingPage from "@/pages/LandingPage";
import Pricing from "@/pages/Pricing";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsOfService from "@/pages/TermsOfService";
import OrganisationSetup from "@/pages/OrganisationSetup";
import PostOnboarding from "@/pages/PostOnboarding";
import OnboardingChat from "@/pages/OnboardingChat";
import WordPressOAuthCallback from "@/pages/WordPressOAuthCallback";
import { AuthWrapper } from "@/app/AuthWrapper";

export const publicRoutes: RouteObject[] = [
  {
    index: true,
    element: <Navigate to="/dashboard" replace />,
  },
  {
    path: "pricing",
    element: <Pricing />,
  },
  {
    path: "privacy-policy",
    element: <PrivacyPolicy />,
  },
  {
    path: "terms-of-service",
    element: <TermsOfService />,
  },
  {
    path: "setup",
    element: (
      <AuthWrapper>
        <OrganisationSetup />
      </AuthWrapper>
    ),
  },
  {
    path: "onboarding",
    element: <PostOnboarding />,
  },
  {
    path: "chat-intro",
    element: <OnboardingChat />,
  },
  {
    path: "wordpress-oauth-callback",
    element: <WordPressOAuthCallback />,
  },
];
